import { useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';
import config from 'config';
import { cache } from 'graph_ql';
import { SEARCH_STYLE } from 'graph_ql/search/search_style';
import { useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from 'redux/store';
import utils from 'utils/utils';
import { buildStoreFilter } from '../utils/getQuerySearchStyles';
import { globalActions } from 'redux/global/global.slice';
import { isEqual } from 'lodash';

export const useLoaderStyles = () => {
    const dispatch = useDispatch();
    const store = useSelector((state: RootState) => state.widget.store);
    const me = useSelector((state: RootState) => state.userDetail.me);
    const loaderStyles = useSelector((state: RootState) => state.global.loaderStyles);

    const userGender = utils.getFormattedGender(me?.gender);

    const discoverStyleSearchVariables = useMemo(() => {
        cache.modify({
            fields: {
                locationsInRadius() {
                    return {};
                },
            },
        });

        let filters = `status: published`;
        if (utils.isAppInWidgetMode()) {
            filters += ` AND (${buildStoreFilter(store)})`;
        }
        if (userGender) {
            filters += ` AND genders.value: ${userGender}`;
        }

        return {
            __typename: 'algolia_styles_discover_styles',
            index: config.algolia.algolia_prefix + 'styles',
            query: '',
            filters,
            page: 0,
            hit: 10,
            facets: [],
        };
    }, [store, userGender]);

    // Lazy query
    const [fetchStyles, { loading, data }] = useLazyQuery(SEARCH_STYLE, {
        variables: discoverStyleSearchVariables,
        fetchPolicy: 'cache-first',
    });

    // Effect to decide when to fetch
    useEffect(() => {
        // use redux value if present, otherwise fetch
        if (!loaderStyles || loaderStyles.length === 0) {
            fetchStyles();
        }
    }, [loaderStyles, fetchStyles]);

    // Save to redux if needed
    useEffect(() => {
        if (!isEqual(loaderStyles, data?.locationsInRadius?.hits) && data?.locationsInRadius?.hits) {
            dispatch(globalActions.setLoaderStyles(data.locationsInRadius.hits));
        }
    }, [loaderStyles, data, dispatch]);

    const listStyles = useMemo(() => {
        if (loaderStyles?.length) {
            return loaderStyles || [];
        }
        return data?.locationsInRadius?.hits || [];
    }, [loaderStyles, data]);

    return { loading, listStyles };
};
